interface Options {
  paths?: string[];
  secure?: boolean;
}

const mainDomain = process.env.NEXT_PUBLIC_SITE_URL;

/**
 * Remove cookies whose names start with any of the given prefixes. This is useful for clearing out
 * old cookies that may have been set with different paths, domains, or secure flags.
 */
export function clearOldCookies(prefixes?: string[], options: Options = {}) {
  const url = mainDomain ? mainDomain : 'partysupplies.com';

  const defaultPrefixes = [
    'store-id',
    'store-id-preferred',
    'store-id-user-selected',
    'UserInterfaceState',
    'OrderState',
    'SPECS_OrderState',
    '_FulfillmentState',
    'sbjs_',
    'age_verified',
    'woocommerce_',
    'wordpress_',
    'wp_',
  ];

  const prefixesToMatch = prefixes && prefixes.length ? prefixes : defaultPrefixes;

  function normalizeDomainFromUrl(value: string | undefined): string {
    if (!value) return '';

    try {
      const parsed = new URL(value);
      return parsed.hostname.replace(/^https?:\/\//, '').replace(/^www\./, '');
    } catch {
      return value.replace(/^https?:\/\//, '').replace(/^www\./, '');
    }
  }

  const paths = options.paths?.length ? options.paths : ['/'];
  const domains: string[] = [];
  const cleanDomain = normalizeDomainFromUrl(url);

  domains.push(cleanDomain);
  domains.push(`.${cleanDomain}`);

  const secure = options.secure === true;

  const cookieNames = document.cookie
    .split(';')
    .map(part => part.trim().split('=')[0])
    .filter(Boolean);

  const matchesPrefix = (name: string) => prefixesToMatch.some(prefix => name.startsWith(prefix));

  const deleteCookie = (name: string, path: string, domain: string) => {
    const expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
    const base = `${name}=; Expires=${expires}; Path=${path}; Domain=${domain}; SameSite=Lax`;
    document.cookie = secure ? `${base}; Secure` : base;
  };

  cookieNames.forEach((name) => {
    if (!matchesPrefix(name)) return;
    domains.forEach((domain) => {
      paths.forEach((path) => {
        deleteCookie(name, path, domain);
      });
    });
  });
}
